"use client";
import BFLTabs from "@repo/shared-ui/BFLTabs";
import { useState } from "react";
import { StocksGrid } from "./StockGrid";
import { TopCategoriesClientProps } from "./types";
import BFLLink from "@repo/shared-ui/BFLLink";
import { dlElementConstants, dlEventConstants, componentNameConstants } from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import { StockItem } from "../../types/stocks";

const TopCategoriesClient = ({
  stocksData,
  defaultImage,
  tabs,
  viewAllLabel,
  stockNotFoundImgUrl,
  stockNotFoundText,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
}: TopCategoriesClientProps) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.value || "top-gainers");
  const [index, setIndex] = useState(0);

  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    const tabIndex = tabs.findIndex((tab) => tab.value === newTab);
    setIndex(tabIndex);
    const data = {
      section_title: componentNameConstants.TOP_CATEGORIES,
      component: componentNameConstants.TOP_CATEGORIES,
      event: dlEventConstants.CLICK,
      element: dlElementConstants.TOP_CATEGORIES_TAB_CLICK,
      cta_text: newTab,
      event_type: dlEventConstants.TAB_CLICK,
      tab_position: (tabIndex + 1).toString(),
    };
    const cleverTapObj = {
      EP_PAGE_NAME: dlElementConstants.TRADING_MALL_CLP,
      EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_CLP_EP,
      EP_TAB: newTab,
    };
    dataLayer("", data, cleverTapObj);
  };
  const handleCardClick = (stock: StockItem,) => {
    const url = window.location?.href?.includes("stock-and-trading");
    const data = {
      section_title: componentNameConstants.TOP_CATEGORIES,
      component: componentNameConstants.TOP_CATEGORIES,
      event: dlEventConstants.CLICK,
      element: dlElementConstants.VIEW_ALL_CLICK,
      cta_text: activeTab,
      event_type: dlEventConstants.CARD_CLICK,
      destination_url: stock?.redirectURL,
    };

    const cleverTapObj = {
      EP_PAGE_NAME: dlElementConstants.TRADING_MALL_CLP,
      EP_TILE_CLICKED: stock.fullName,
      EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_CLP_EP,
      // EVENT_NAME: url ? dlElementConstants.CLP_CLICK : dlElementConstants.PLP_CLICKED,
    };
    dataLayer("", data, cleverTapObj);
  };

  const data = {
    section_title: componentNameConstants.TOP_CATEGORIES,
    component: componentNameConstants.TOP_CATEGORIES,
    event: dlEventConstants.CLICK,
    element: dlElementConstants.VIEW_ALL_CLICK,
    cta_text: componentNameConstants.VIEW_ALL_CATEGORIES,
    event_type: dlEventConstants.BUTTON_CLICK,
    destination_url: tabs[index]?.redirectLink,
  };

  const cleverTapObj = {
    EP_PAGE_NAME: dlElementConstants.TRADING_MALL_CLP,
    EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_CLP_EP,
    EP_CTA: dlElementConstants.VIEW_ALL_CLICK,
    EP_TILE_CLICKED: ""
  };

  return (
    <>
      <BFLTabs
        tabs={tabs}
        selectedTab={activeTab}
        onTabChange={handleTabChange}
        className="mb-[16px] border-b border-gray-300 px-0 pb-0 text-[12px] lg:text-[16px]"
        tabClassName="px-[6px] py-1 "
        gapClassName="space-x-[6px]"
        color="text-[#002953]"
        indicatorClassName="md:bottom-[0px] bottom-[0px]"
        paragraphClassName="pb-[16px]"
      />

      <StocksGrid
        key={activeTab}
        stocks={
          activeTab === "top-gainers"
            ? stocksData?.topgainers?.stockList
            : activeTab === "top-losers"
              ? stocksData?.toplosers?.stockList
              : activeTab === "52-weeks-high"
                ? stocksData?.weekshigh?.stockList
                : stocksData?.weekslow?.stockList
        }
        defaultImage={defaultImage}
        errorMessage={stockNotFoundText}
        stockNotFoundImgUrl={stockNotFoundImgUrl}
        modalTitle={modalTitle}
        modalBtnCta={modalBtnCta}
        successMsg={successMsg}
        errorMsg={errorMsg}
        onCardClick={handleCardClick}
        cta_text={activeTab}
        section_title={"TOP_CATEGORIES"}
      />
      <BFLLink openInNewTab href={tabs[index]?.redirectLink} ctProps={JSON.stringify(cleverTapObj)} dlProps={JSON.stringify(data)}>
        <div className="mt-[8px] max-w-fit cursor-pointer border-0 bg-transparent px-0 pb-[4px] pt-[8px] text-left transition-opacity duration-200 ease-linear">
          <button
            type="button"
            className="text-link-primary h-[18px] cursor-pointer text-[14px] font-[500]"
          >
            {tabs[index]?.viewAlltext || viewAllLabel}
          </button>
        </div>
      </BFLLink>
    </>
  );
};

export default TopCategoriesClient;
